export default "__VITE_ASSET__VuTzOZ6q__"